import Popover from "components/Popover/Popover";
import { useSelector } from "react-redux";
import { selectState, setIncidentPopover } from "../main.slice";
import { useAppDispatch } from "hooks/hooks";
import { FormatNumber } from "utils/numberUtils";
import { FormatDate } from "utils/dateUtils";

const IncidentsPopover = () => {
  const { selectedIndex, incidentsPopover, partners } = useSelector(selectState);
  const dispatch = useAppDispatch();
  const item = partners[selectedIndex];

  return (
    <Popover
      isOpen={incidentsPopover.isOpen}
      onClose={() => dispatch(setIncidentPopover({ isOpen: false }))}
      title="Incidenti"
      direction="right"
      arrowStyle={{ top: "50%" }}
      position={{
        top: incidentsPopover.top,
        left: incidentsPopover.left,
        offsetLeft: 20,
        offsetTop: -113 - 65 * ((item?.incidents?.length || 0) - 1),
      }}
    >
      <div className="partners-incidents">
        {item?.incidents &&
          item.incidents.map((incident, index) => (
            <div className="partners-row-tooltip" key={index}>
              <div>
                <span>{FormatNumber(incident.amount)} rsd</span>
                <span>{FormatDate(incident.date)}</span>
              </div>
              <label>{incident.incidentType}</label>
              <label>{incident.projectName}</label>
              <textarea>{incident.description}</textarea>
            </div>
          ))}
      </div>
    </Popover>
  );
};

export default IncidentsPopover;
